import React from 'react';
import { FadeIn } from './FadeIn';
import { Download, PlusCircle, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-8 h-8 text-white" data-id="element-76" />,
    title: 'Descarga la Guía',
    desc: 'Recibe acceso inmediato a tu protocolo de 7 días'
  }, {
    icon: <PlusCircle className="w-8 h-8 text-white" data-id="element-77" />,
    title: 'Integra los Aliados',
    desc: "Suma la nutrición dirigida (Women's Choice + Tang Kuei) a tu rutina"
  }, {
    icon: <Sparkles className="w-8 h-8 text-white" data-id="element-78" />,
    title: 'Vive el Cambio',
    desc: 'Siente cómo la inflamación baja y la claridad mental regresa en tu primera semana'
  }];
  return <section className="py-20 px-6 md:px-12 bg-cream" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <FadeIn data-id="element-81">
          <div className="text-center mb-16" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-83">
              Así de Simple
            </h2>
            <div className="w-24 h-1 bg-copper mx-auto rounded-full" data-id="element-84"></div>
          </div>
        </FadeIn>

        <div className="relative" data-id="element-85">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-copper/20 -z-10" data-id="element-86"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-87">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-88">
                <div className="flex flex-col items-center text-center relative" data-id="element-89">
                  <div className="w-24 h-24 bg-rose-gold rounded-full flex items-center justify-center shadow-lg mb-6 border-4 border-cream relative z-10" data-id="element-90">
                    {step.icon}
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-warm-dark text-white rounded-full flex items-center justify-center font-bold font-serif text-sm border-2 border-cream" data-id="element-91">
                      {index + 1}
                    </div>
                  </div>
                  <h3 className="text-xl font-serif font-bold text-warm-dark mb-3" data-id="element-92">
                    {step.title}
                  </h3>
                  <p className="text-warm-dark/70 font-sans" data-id="element-93">{step.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}